// View --->
function MakeViewActive(button) {
  const spans = button.querySelectorAll('.cells_dd2 span');
  let currentIndex = -1;
  spans.forEach((span, i) => {
    if (span.classList.contains('filled')) currentIndex = i;
  });
  if (currentIndex === spans.length - 1) {
    spans.forEach((span) => span.classList.remove('filled'));
    spans[0].classList.add('filled');
  } else {
    spans[currentIndex + 1].classList.add('filled');
  }
}

// Model --->
function MakeModelActive(element) {
  element.classList.toggle('active_dd1');
}

// Hide loox reviews if less than 4 -->
(function () {
  function hideLoox() {
    const looxWidget = document.querySelector('.loox-rating.loox-widget');
    if (!looxWidget) return;

    const rating = parseFloat(looxWidget.getAttribute('data-rating'));
    const reviews = parseInt(looxWidget.getAttribute('data-raters') || '0', 10);

    if (reviews === 0 || (!isNaN(rating) && rating < 4)) {
      looxWidget.closest('a')
        ? looxWidget.closest('a').style.display = 'none'
        : looxWidget.style.display = 'none';

      document.querySelectorAll('accordion-disclosure').forEach(function (acc) {
        if ((acc.querySelector('summary')?.textContent || '').toLowerCase().includes('review')) {
          acc.style.display = 'none';
        }
      });
    }
  }

  // Run immediately
  hideLoox();

  // Run again after Loox finishes rendering
  window.addEventListener('load', hideLoox);
  setTimeout(hideLoox, 500);
  setTimeout(hideLoox, 1000);
  setTimeout(hideLoox, 2000);

  // Keep watching for Loox updates
  new MutationObserver(hideLoox).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });
})();
